<template>
  <h2>tt</h2>
</template>
<script>
import {computed, reactive } from 'vue'
import { useHead } from '@vueuse/head'
export default {
  name:'Store',
  setup() {
      const siteData = reactive({
      title: `스토어 - WithYou 위드유치료교육연구소`,
      description: 'WithYou 위드유치료교육연구소 스토어를 소개합니다.',
      })
      useHead({
          title: computed(() => siteData.title),
          meta: [
                  {
                      name: `description`,
                      content: computed(() => siteData.description),
                  },
          ],
      })
  },
}
</script>
